import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './services/auth.service';
import { isMobileViewport } from './utils/mobile-viewport.utils';

@Injectable({
  providedIn: 'root',
})
export class AdminMobileGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isCurrentUserAdmin() || !isMobileViewport()) {
      return true;
    }

    this.router.navigate(['/mobile-desktop'], {
      queryParams: { redirect: state.url },
    });
    return false;
  }
}
